
export type SearchMessages200Item = {
  content: string;
  contentType: string;
  /** @nullable */
  id?: number | null;
  /** @nullable */
  mediaUrl?: string | null;
  /** @nullable */
  replyContent?: string | null;
  /** @nullable */
  replyToMessageId?: string | null;
  roomId: string;
  sent: string;
  userId: string;
};
